var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "800px" },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "span",
                { staticClass: "headline text-uppercase font-weight-medium" },
                [_vm._v("\n        Motivo do evento\n      ")]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "accent",
                    rounded: "",
                    icon: "",
                    outlined: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeDialog()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              this.event != "activate"
                ? _c("v-select", {
                    attrs: {
                      required: "",
                      autofocus: "",
                      label: "Selecione uma operação",
                      name: "operation",
                      "prepend-inner-icon": "mdi-account-reactivate",
                      items: _vm.possibleOperations
                    },
                    on: { input: _vm.setOperation }
                  })
                : _vm._e(),
              _vm._v(" "),
              this.event != "activate"
                ? _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.option,
                        callback: function($$v) {
                          _vm.option = $$v
                        },
                        expression: "option"
                      }
                    },
                    [
                      _vm._l(_vm.possibleDescriptions, function(description) {
                        return _c("v-radio", {
                          key: description.value,
                          attrs: {
                            label: description.text,
                            value: description.value
                          },
                          on: {
                            change: function($event) {
                              _vm.textField = false
                            }
                          }
                        })
                      }),
                      _vm._v(" "),
                      _c("v-radio", {
                        attrs: { label: "outro" },
                        on: {
                          change: function($event) {
                            _vm.textField = true
                          }
                        }
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.textField == true || this.event === "activate"
                ? _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:100",
                        expression: "'required|max:100'"
                      }
                    ],
                    attrs: {
                      required: "",
                      name: "description",
                      label: "Descricao",
                      "data-vv-as": "Descricao",
                      "prepend-inner-icon": "mdi-format-title",
                      counter: 100,
                      value: _vm.description,
                      error: _vm.errors.has("title"),
                      "error-messages": _vm.errors.first("title")
                    },
                    on: { input: _vm.commitOption }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        large: "",
                        loading: _vm.statusPreloader
                      },
                      on: {
                        click: function($event) {
                          return _vm.changeStatus(_vm.event)
                        }
                      }
                    },
                    [_c("span", [_vm._v("Enviar")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c191945e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c191945e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Forms/Description.vue
// module id = null
// module chunks = 